export default __webpack_public_path__ + "static/media/flag-turks-and-caicos-islands.db73ca52.svg";